import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import SectionTitle from '@client/components/texts/SectionTitle';
import DisplayBox from '@client/components/displayBox/DisplayBox';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './itemList.scss';

class ItemList extends PureComponent {
  render() {
    const {
      className,
      sectionTitle,
      items,
      getItemRoute,
      itemOverlay,
    } = this.props;
    return (
      <div
        className={
          className
            ? `${styles.contentContainer} ${className}`
            : styles.contentContainer
        }
      >
        <SectionTitle
          title={sectionTitle}
          className={themeStyles.headerLarge}
          linkTextNotActive={true}
        />
        <div className={styles.gridContainer}>
          {items.map((item, index) => {
            return (
              <DisplayBox
                key={index}
                itemOverlay={itemOverlay}
                className={styles.gridElement}
                title={item.title}
                categoryTitle={item.categoryTitle}
                categoryColor={item.categoryColor}
                imgSrc={item.thumbnailImageUrl}
                alt={item.title}
                sponsor={item.sponsor ? item.sponsor : undefined}
                route={getItemRoute(item)}
                numOfEpisodes={item.episodeCount}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

ItemList.propTypes = {
  className: PropTypes.string,
  sectionTitle: PropTypes.string,
  items: PropTypes.array.isRequired,
  getItemRoute: PropTypes.func,
  itemOverlay: PropTypes.bool,
};

export default ItemList;
